<template>
  <WithDimensions>
    <template v-slot:default="{ width }">
      <article>
        <div class="side-image">
          <RichImage v-if="width >= 768" :field="article.image" />
        </div>
        <div class="content">
          <RichText :field="article.header" class="marked" />
          <RichImage v-if="width < 768" :field="article.image" />
          <RichText :field="article.content" />
        </div>
      </article>
    </template>
  </WithDimensions>
</template>

<script>
import WithDimensions from './WithDimensions';

export default {
  components: {
    WithDimensions
  },
  props: {
    article: {
      type: Object,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/helpers/mixins';

.last-article {
  border-bottom: 1px $grey-3 solid;
  margin-bottom: 30px;
}

article {
  max-width: 1000px;
  margin: 30px auto;
  padding: 0 20px;

  ::v-deep img {
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

@include breakpoint(M) {
  .last-article {
    margin-bottom: 60px;
  }

  article {
    display: flex;

    .side-image {
      flex: 1;
      padding-right: 30px;

      [dir='rtl'] & {
        padding-right: 0;
        padding-left: 30px;
      }
    }

    .content {
      flex: 1;
      padding-left: 30px;

      [dir='rtl'] & {
        padding-left: 0;
        padding-right: 30px;
      }
    }
  }
}
</style>
